<template>
	<div v-if="!hideForSSO" class="game-container">
		<div style="cursor: unset" class="img-container">
			<img :src="game.img" alt="" />
		</div>
		<div class="add-container add-container-game">
			<div>
				<p>{{ game.title }}</p>
			</div>
			<a v-if="game.url" :href="game.url" class="submit add">
				<span>Ouvrir</span>
			</a>
			<router-link
				class="submit add"
				v-if="game.componentName"
				:to="{ name: game.componentName }"
			>
				<span>Ouvrir</span>
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		game: {
			type: Object,
			required: true
		}
	},
	computed: {
		isSSO() {
			return this.$store.getters.isSSO
		},
		hideForSSO() {
			return this.isSSO && this.isAdventCalendar(this.game && this.game.title)
		}
	},
	methods: {
		isAdventCalendar(title) {
			const n = this.normalizeTitle(title)
			// tolère variantes: "le calendrier de l'avent"/"le calendrier de l’avant"/"le calendrier de l'avant"
			const withoutLe = n.startsWith('le ') ? n.slice(3) : n
			return (
				withoutLe.includes('calendrier') &&
				(withoutLe.includes('avent') || withoutLe.includes('avant'))
			)
		},
		normalizeTitle(s) {
			return (s || '')
				.toString()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '') // strip accents
				.replace(/[’']/g, ' ') // apostrophes -> space
				.replace(/\s+/g, ' ') // collapse spaces
				.trim()
				.toLowerCase()
		}
	}
}
</script>

<style>
</style>
